import { useCallback, useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { isSoftPhoneActive, useSoftPhone } from '@/contexts/softPhoneContext';
import usFormatPhoneNumber from '@/utils/usFormatPhoneNumber';

const useStartCall = (personId: string) => {
  const { addMessage } = useContext(AppContext);
  const softPhone = useSoftPhone();

  return useCallback(
    (number: string) => {
      if (!isSoftPhoneActive(softPhone)) return;
      softPhone.startCall(number, personId).catch((err: unknown) => {
        const message = err instanceof Error ? err.message : '';
        addMessage(
          'error',
          message || `Failed to connect call to ${usFormatPhoneNumber(number)}. Please try again.`
        );
      });
    },
    [addMessage, personId, softPhone]
  );
};

export default useStartCall;
